<template>
  <a-card v-if="pageLoading">
    <a-spin tip="Your document is being processed, do not leave this page!" :spinning="pageLoading"></a-spin>
  </a-card>
  <a-row :gutter="8" v-else>
    <a-col :xs="{ span: 24 }">
      <a-form :form="form">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="UM Detail">
              <a-select showSearch allowClear @search="handleppdtl" @change="handleChangeumDtl"
                optionFilterProp="children" :filterOption="filterOption"
                v-decorator="['um_dtl', { rules: [{ required: true }], initialValue: undefined }]">
                <a-select-option v-for="item in ppdetillist" :key="item.id_um_dtl">
                  <!-- <table style="width:100%">
                    <tr>
                      <td>
                        <span> {{item.item_nm}}</span>
                      </td>
                      <td>
                        <b style="float:right">&nbsp;&nbsp;&nbsp;{{formatCurrency(item.currency,parseFloat(item.saldo_um))}} </b>
                      </td>
                    </tr>
                  </table> -->
                  <div class="elipsdiv">
                    <div class="elipsdiv-mouseover-label1">
                      {{ item.item_nm }}</div>
                    <div class="elipsdiv-mouseover-label2">
                      <b style="float: right">{{
                        formatCurrency(item.currency, parseFloat(item.saldo_um))
                      }}
                      </b>
                    </div>
                  </div>
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Usage Date">
              <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat"
                v-decorator="['tanggal_pemakaian', { rules: [{ required: true }] }]" />
            </a-form-item>
            <a-form-item label="Description">
              <a-input v-decorator="['deskripsi', { rules: [{ required: true }] }]"></a-input>
            </a-form-item>
            <a-form-item label="Credit">
              <a-input-number class="m-width-full m-text-align-right" :min="0"
                :formatter="value => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="['kredit', { rules: [{ required: true }, { validator: checkPrice }] }]" />
            </a-form-item>
            <a-row :gutter="12">
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-item label="Is Commission?">
                  <a-radio-group v-decorator="[
                    'iscommision',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]" :disabled="EnCommission" button-style="solid" @change="handleOptionCommission">
                    <a-radio-button value="1"> Yes </a-radio-button>
                    <a-radio-button value="0"> No </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                <a-form-item label="With Note?" :hidden="true">
                  <a-radio-group v-decorator="[
                    'without_note',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]" button-style="solid">
                    <a-radio-button value="0"> Yes </a-radio-button>
                    <a-radio-button value="1"> No </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="Upload Transaction Document">
              <a-upload :showUploadList="true" :fileList="doctransfiles" :beforeUpload="beforedoctransUpload"
                :remove="handledoctransRemove" v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]">
                <a-button>
                  <a-icon type="upload" />&nbsp;Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-divider class="margin-bottom-small">or</a-divider>
      <div>
        <h4>Upload File Excel</h4>
        <p>
          If You Don't Have a File Upload Template, Please
          Click
          <a-button class="padding-remove" type="link" @click="handleDownload">Download Template</a-button>
        </p>
        <a-upload accept=".xls, .xlsx" :showUploadList="true" :fileList="push" :beforeUpload="beforeUpload"
          @change="handleChange" :remove="handleRemove" v-decorator="['upload', { valuePropName: 'push' }]">
          <a-button>
            <a-icon type="upload" />&nbsp;Select File
          </a-button>

        </a-upload>
        <a-divider v-if="getScreen"></a-divider>
      </div>
      <a-button v-if="getScreen" type="primary" block @click="handleNew" :loading="newLoading">Add</a-button>
    </a-col>
    <a-col :xs="{ span: 24 }" v-if="getScreen">
      <a-collapse class="margin-top">
        <a-collapse-panel key="1">
          <h4 slot="header" class="margin-remove">View Details</h4>
          <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
            <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <a-row slot="title" type="flex" justify="space-between">
                  <a href="#">{{ item.deskripsi }}</a>
                </a-row>
                <p slot="description">
                <ul class="m-list-wrapper">
                  <li class="margin-remove">
                    {{ item.tanggal }}
                  </li>
                  <li v-if="item.debit !== ''">
                    <h4 class="margin-remove m-text-sub">Debit</h4>
                    <h3 class="margin-remove">{{ formatCurrency(mata_uang, item.debit) }}</h3>
                  </li>
                  <li v-else>
                    <h4 class="margin-remove m-text-sub">Credit</h4>
                    <h3 class="margin-remove">{{ formatCurrency(mata_uang, item.kredit) }}</h3>
                  </li>
                </ul>
                </p>
              </a-list-item-meta>
              <a-button-group v-if="getScreen && item.kredit !== ''">
                <a-button type="primary" @click="handleEdit(item)">
                  <a-icon type="edit" />&nbsp;Edit
                </a-button>
                <a-button type="danger" @click="handleRemoveDetail(item)">
                  <a-icon type="close" />&nbsp;Remove
                </a-button>
              </a-button-group>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
      <div class="m-price-total" v-if="pageLoading === false">
        <div class="m-display-flex space-between align-middle">
          <h4>Debit</h4>
          <h3>{{ formatCurrency(mata_uang, debit) }}</h3>
        </div>
        <div class="m-display-flex space-between align-middle">
          <h4>Credit</h4>
          <h3>{{ formatCurrency(mata_uang, initialList.kredit) }}</h3>
        </div>
        <a-divider class="margin-small"></a-divider>
        <div class="m-display-flex space-between align-middle">
          <h4>Remaining Balance</h4>
          <h3>{{ formatCurrency(mata_uang, initialList.saldo) }}</h3>
        </div>
      </div>
      <!-- <a-checkbox :disabled="dataList.length <= 1 || (mode === 'Edit' && type==='revised')" @change="handleCheckData">Is Data Completed?</a-checkbox> -->
    </a-col>

    <a-modal title="Confirmation" :ppdetillist="ppdetillist" :visible="confirm" @ok="handleOk"
      :confirmLoading="confirmLoading" @cancel="handleCancel" okText="OK" cancelText="Cancel" :maskClosable="false">
      <p>The data that has been added will be overwritten with your new file? Are you sure?</p>
    </a-modal>
    <Modal :data="modal.data" :modalEdit="modal.modalEdit" :confirmLoading="modal.confirmLoading" />
  </a-row>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Modal from "../Modal.vue";
import _ from "lodash";

export default {
  name: "pemakaian",
  components: {
    Modal,
  },
  mixins: [CurrencyFormat],
  props: {
    data: {},
    informasi: {},
    mode: {},
    url: "",
    id_lk: "",
    dataList: {},
    debit: 0,
    kredit: 0,
    mata_uang: "",
    type: "",
    limitasi: Number,
  },
  data() {
    return {
      ppdetillist: [],
      push: [],
      confirm: false,
      confirmLoading: false,
      newLoading: false,
      pageLoading: true,
      pagination: {
        onChange: (page) => { },
        pageSize: 5,
        size: "small",
      },
      initialEdit: {},
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: "",
          id: "",
        },
      },
      headers: {
        authorization: "authorization-text",
      },
      EnCommission: false,
      Viwithout_note: true,
      doctransfiles: [],
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getScreen", "getDefaultDateFormat"]),
    initialList() {
      let list = {};
      if (this.dataList.length > 0) {
        let kredit = 0;
        let saldo = 0;
        let data = this.dataList.slice(1);
        if (this.dataList.length > 1 || this.dataList !== undefined) {
          data.forEach((item) => {
            kredit = parseInt(kredit) + parseInt(item.kredit);
          });
        }
        saldo = this.debit - kredit;

        list = { kredit: kredit, saldo: saldo };
      }

      return list;
    },
  },
  created() {
    this.fetchPemakaian();
    this.fetchAttribute();
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formEdit = this.$form.createForm(this);
  },
  methods: {
    moment,
    // simulation(arr){
    //   let result = true
    //   if(this.ppdetillist.length>0){
    //     for (let index = 0; index < this.ppdetillist.length; index++) {
    //         this.ppdetillist[index].temp_saldo_um = this.ppdetillist[index].saldo_um_origin
    //       }
    //   }

    //   if(arr.length>0){
    //     arr.forEach(ment => {
    //       let ppdtl=ment.id_um_dtl
    //       for (let index = 0; index < this.ppdetillist.length; index++) {
    //         const elem = this.ppdetillist[index].id_um_dtl;
    //         if (elem==ppdtl){
    //             this.ppdetillist[index].temp_saldo_um = 
    //             parseFloat(this.ppdetillist[index].temp_saldo_um) - parseFloat(ment.kredit)
    //             break
    //         }
    //       }
    //     });
    //   }
    //   console.log("this.ppdetillist",this.ppdetillist)
    //   this.ppdetillist.forEach(element => {
    //     if (parseFloat(element.temp_saldo_um) < 0){
    //       result = false
    //     }
    //   });
    //   return result
    // },
    // recountingBalance(arr){
    //   if (this.ppdetillist){
    //     if(this.ppdetillist.length>0){
    //       for (let index = 0; index < this.ppdetillist.length; index++) {
    //           this.ppdetillist[index].saldo_um = this.ppdetillist[index].saldo_um_origin
    //         }
    //     }
    //     console.log("recountingBalance","arr",arr)
    //     if(arr.length>1){
    //       arr.forEach(ment => {
    //         let ppdtl=ment.id_um_dtl
    //         for (let index = 0; index < this.ppdetillist.length; index++) {
    //           const elem = this.ppdetillist[index].id_um_dtl;
    //           if (elem==ppdtl){
    //               this.ppdetillist[index].saldo_um = 
    //               parseFloat(this.ppdetillist[index].saldo_um) - parseFloat(ment.kredit)
    //               break
    //           }
    //         }
    //       });
    //     }
    //   }
    // },
    fetchAttribute() {
      const ppdetil = axios({
        method: "get",
        params: {
          id_um: this.informasi.id_um,
        },
        url: this.$serviceUrl + "lap_um_pp/um_detil",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      return axios
        .all([
          ppdetil.catch(err => {
            console.log(err);
            return null;
          }),
        ])
        .then(response => {
          if (response[0] !== undefined) {
            this.ppdetillist = response[0].data.list_nama_item;
          } else {
            this.ppdetillist = [];
          }
          // if (this.dataList.length>0){
          //     this.recountingBalance(this.dataList)
          //   }
        })
        .catch(err => {
          console.log(err);
          // this.pageLoading = false;
        });
    },
    handleppdtl() {
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.push = [file];
        this.form.resetFields();
        return false;
      }
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    done() {
      this.pageLoading = false;
    },
    fetchPemakaian() {
      this.pageLoading = true;
      Event.$emit("fetchPemakaian", true);
      // let arr = this.dataList.filter(
      //   (item) => item.kredit !=="" 
      // )
      // console.log("this.",this.dataList,arr)
      // if(arr.length>0){
      //   console.log("masuk lur")
      //   this.recountingBalance(arr)
      // }
    },
    handleRemoveDetail(e) {
      Event.$emit("removeDetail", e);
    },
    handleRemove() {
      this.push = [];
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
    handleOk(e) {
      Event.$emit("handleLoading", true);
      this.ModalText = "The modal will be closed after two seconds";
      this.confirmLoading = true;

      let addData = new FormData();

      addData.append("tlc", this.getAuth.username);
      addData.append("id_lk", this.id_lk);
      addData.append("no_um", this.informasi.no_um);
      addData.append(
        "tanggal_pelaporan",
        this.informasi.tanggal_pelaporan.format(this.getDefaultDateFormat)
      );
      this.push.forEach((file) => {
        addData.append("file_upload", file);
      });
      addData.append("isparsial", this.informasi.isparsial);

      this.postUpload(addData);
    },
    handleCancel(e) {
      this.confirm = false;
      this.modal.modalEdit = false;
      Event.$emit("handleLoading", false);
    },
    handleNew() {
      Event.$emit("handleLoading", true);
      let addData = new FormData();
      addData.append("tlc", this.getAuth.username);
      addData.append("id_lk", this.id_lk);
      addData.append("no_um", this.informasi.no_um);
      addData.append(
        "tanggal_pelaporan",
        this.informasi.tanggal_pelaporan.format("YYYY-MM-DD")
      );
      addData.append("isparsial", this.informasi.isparsial);
      addData.append("without_note", "1");

      if (this.push.length > 0 && this.dataList.length > 1) {
        this.confirm = true;
      } else if (this.push.length > 0) {
        addData.append("iscommision", "0");
        this.push.forEach((file) => {
          addData.append("file_upload", file);
        });

        this.newLoading = true;
        this.pageLoading = true;

        this.postUpload(addData);
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.newLoading = false;
            this.pageLoading = false;
            Event.$emit("handleLoading", false);
            this.displayMessage("form-warning");
            return;
          }

          if(moment(values.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
            Event.$emit("handleLoading", false);
            this.displayMessageValue("error-other", "Usage date can't exceed today!");
            return;
          }
          
          addData.append(
            "tanggal_pemakaian",
            values.tanggal_pemakaian.format("YYYY-MM-DD")
          );
          addData.append("deskripsi", values.deskripsi);
          addData.append("kredit", values.kredit);
          addData.append("id_um", this.informasi.id_um);
          addData.append("tanggal_pelaporan", this.informasi.tanggal_pelaporan.format("YYYY-MM-DD"))
          addData.append("um_dtl", values.um_dtl)
          addData.append("isparsial", this.informasi.isparsial);
          addData.append("iscommision", values.iscommision);
          // addData.append("without_note", values.without_note);
          addData.append("without_note", "1");

          if (this.doctransfiles && this.doctransfiles.length > 0) {
            this.doctransfiles.forEach((file) => {
              addData.append("file_upload", file);
            });
          }

          this.newLoading = true;

          axios({
            method: "post",
            url: this.url,
            processData: false,
            data: addData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success-add");
              this.fetchPemakaian();
              // let arr = this.dataList.filter(
              //   (item) => item.kredit !=="" 
              // )
              // console.log("this.",this.dataList,arr)
              // if(arr.length>0){
              //   this.recountingBalance(arr)
              // }
              this.newLoading = false;
              this.pageLoading = false;
              this.form.resetFields();
              this.push = [];
              this.doctransfiles = [];
              if (this.mode === "Create") {
                Event.$emit("disableInformasi", true);
              }
            })
            .catch((err) => {
              Event.$emit("handleLoading", false);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
              console.log("error : " + err);
            });
        });
      }
    },
    postUpload(data) {
      let urlApi = "";
      if (this.type == "revised") {
        urlApi = "lap_um_pp/revisi_upload_detil_pemakaian";
      } else {
        urlApi = "lap_um_pp/upload_detil_pemakaian";
      }

      //console.log(urlApi);
      axios({
        method: "post",
        url: this.$serviceUrl + urlApi,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (this.mode === "Create") {
            this.displayMessage("success-add");
            this.fetchPemakaian();
            this.newLoading = false;
            this.pageLoading = false;
            this.confirm = false;
            Event.$emit("disableInformasi", true);
          } else {
            this.displayMessage("success-edit");
            this.fetchPemakaian();
            this.newLoading = false;
            this.pageLoading = false;
            this.confirm = false;
            Event.$emit("disableInformasi", true);
          }
          this.push = [];
          Event.$emit("handleLoading", false);
          this.confirmLoading = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response);
          //console.log(responses)
          if (responses.data) {
            if (
              err.response.data.message ===
              "Total nilai yang Diinputkan melebihi limit nilai Laporan UM"
            ) {
              this.displayMessageValue(
                "limit-lap",
                this.formatCurrency(this.mata_uang, this.debit + this.limitasi)
              );
            } else if (err.response.data.message === "Upload failed. File is empty") {
              this.displayMessage("wrong-format");
            } else {
              //this.displayMessage("error-upload");
              this.displayMessageValue("error-other", responses.data.message);
            }
          } else {
            this.displayMessageValue("error-other", responses);
          }
          this.confirmLoading = false;
          this.newLoading = false;
          this.pageLoading = false;
          this.confirm = false;
          Event.$emit("disableInformasi", true);
          Event.$emit("handleLoading", false);
        });
    },
    handleCheckData(e) {
      Event.$emit("draftStatus", e.target.checked);
    },
    handleEdit(item) {
      this.modal.data = { pageloading: true }
      this.modal.data = {
        ppdetillist: this.ppdetillist,
        selected_um_dtl: item.id_um_dtl,
        tanggal_pemakaian: item.tanggal_pemakaian,
        deskripsi: item.deskripsi,
        kredit: item.kredit,
        id: item.id,
        type: this.id
          ? this.type === "draft"
            ? "edit"
            : "revised"
          : this.type === "revised"
            ? "revised"
            : "edit",
        typeEdit: this.type,
        debit: this.debit,
        limitasi: this.limitasi,
        mata_uang: this.mata_uang,
        pageloading: false,
      };
      this.modal.modalEdit = true;
    },
    handleDownload() {
      axios({
        method: "get",
        url: this.$serviceUrl + "/main/download_template",
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          window.open(this.$serviceUrl + response.data.url, "_blank");
        })
        .catch((err) => {
          this.displayMessage("error-emptyDocTemplate");
        });
    },
    checkPrice(rule, value, callback) {
      if (value > -1) {
        callback();
        return;
      }
      callback("Price must greater than -1 !");
    },
    handleChange(info) {
      if (info.file.status === "removed") {
        this.push = [];
      }
    },
    filterOption(input, option) {
      //console.log(option)
      return (
        option.componentOptions.children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeumDtl(val) {
      let selectedumDtl = _.filter(this.ppdetillist, { id_um_dtl: val });
      if (selectedumDtl[0] && selectedumDtl[0].is_komisi) {
        // this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.form.setFieldsValue({
            iscommision: "1",
            without_note: "0",
          });
        });
      } else {
        // this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.form.setFieldsValue({
            iscommision: "0",
            without_note: "0",
          });
        });
      }
    },
    handleOptionCommission(val) {
      if (val.target.value == "1") {
        this.Viwithout_note = false;
      } else {
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
        this.form.setFieldsValue({
          without_note: "0",
        });
      });
    }
  },
  mounted() {
    Event.$on("modalCancel", this.handleCancel);
  },
  beforeDestroy() {
    Event.$off("modalCancel", this.handleCancel);
  },
};
</script>

<style lang="less">
.select {
  &-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    >div {
      display: flex;
      gap: @padding / 2;
    }
  }

  &-between {
    .ant-select-selection {
      width: 100%;
      display: flex;
      justify-content: space-between;
      float: unset !important;

      &__rendered {
        flex: 1;
        padding-right: @padding;
        display: flex;
        float: unset !important;
      }

      &-selected-value {
        flex: 1;
        float: unset !important;
      }
    }
  }
}

.ant-select-selection-selected-value {
  width: 100% !important;

  .elipsdiv {
    .elipsdiv-mouseover-label1:hover {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>